// =============================================================================
// Watts and Wealth — WebSocket protocol message types (Zod schemas)
// SKELETON ONLY — populated in WEB.6 (multiplayer server phase).
// =============================================================================

import { z } from "zod";

// ---------------------------------------------------------------------------
// Direction tags
// ---------------------------------------------------------------------------

export const ClientToServerTag = {
  JoinRoom: "JoinRoom",
  LeaveRoom: "LeaveRoom",
  PlayerAction: "PlayerAction",
  Ping: "Ping",
} as const;
export type ClientToServerTag = (typeof ClientToServerTag)[keyof typeof ClientToServerTag];

export const ServerToClientTag = {
  RoomJoined: "RoomJoined",
  StateDelta: "StateDelta",
  Error: "Error",
  Pong: "Pong",
  GameOver: "GameOver",
} as const;
export type ServerToClientTag = (typeof ServerToClientTag)[keyof typeof ServerToClientTag];

// ---------------------------------------------------------------------------
// Base envelope (skeleton — full protocol in WEB.6)
// ---------------------------------------------------------------------------

const clientToServerTagValues = ["JoinRoom", "LeaveRoom", "PlayerAction", "Ping"] as const;
const serverToClientTagValues = ["RoomJoined", "StateDelta", "Error", "Pong", "GameOver"] as const;

export const ClientMessageSchema = z.object({
  protocolVersion: z.literal(1),
  tag: z.enum(clientToServerTagValues),
  seatIndex: z.number().int().min(0).max(3),
  clientTimestamp: z.number(),
  /** Action-specific payload — typed per tag in WEB.6. */
  payload: z.unknown(),
});
export type ClientMessage = z.infer<typeof ClientMessageSchema>;

export const ServerMessageSchema = z.object({
  protocolVersion: z.literal(1),
  tag: z.enum(serverToClientTagValues),
  serverTimestamp: z.number(),
  /** Delta-specific payload — typed per tag in WEB.6. */
  payload: z.unknown(),
});
export type ServerMessage = z.infer<typeof ServerMessageSchema>;
